"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var getFiltersFromColumnData = function (data, column) {
    var itemCounts = new Map();
    data.forEach(function (item) {
        var value = column.accessor(item);
        if (itemCounts.has(value)) {
            itemCounts.set(value, itemCounts.get(value) + 1);
        }
        else {
            itemCounts.set(value, 1);
        }
    });
    return Array.from(itemCounts, function (_a) {
        var _b = __read(_a, 2), label = _b[0], count = _b[1];
        return ({ label: label, count: count });
    });
};
exports.default = getFiltersFromColumnData;
